<template>
  <div class="mirror-list">
    <div class="rsync-server">
      <span style="text-align: center;font-size: 15px;">RSYNC服务器：{{rsyncInfo.address.paramValue.length > 0 ? rsyncInfo.address.paramValue : '无'}}</span>

      <el-button type="text" style="margin-left: 30px;" @click.stop="saveRsyncPopShow = true">修改</el-button>
      <el-button type="primary" size="small" @click="advancedShow = !advancedShow" style="margin-left: 50px;">高级筛选</el-button>
    </div>
    <div class="search-advanced" v-show="advancedShow" @keyup.enter="getAllMirrorListForSearch">
      <div class="search-main">
        <div class="search-main-item">
          <span>镜像状态:</span>
          <div class="item-input">
            <el-select v-model="searchInfo.workStatus" size="mini" placeholder="状态">
              <el-option
                      v-for="item in searchOptions.status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="search-main-item">
          <span>云机版本:</span>
          <div class="item-input">
            <el-select v-model="searchInfo.engineType" size="mini" placeholder="云机版本">
              <el-option
                      v-for="item in engineList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="search-main-item">
          <span>上传云机IP:</span>
          <div class="item-input">
            <el-input v-model="searchInfo.deviceIpUpload" size="mini"></el-input>
          </div>
        </div>
        <div class="search-main-item">
          <span>占用云机IP:</span>
          <div class="item-input">
            <el-input v-model="searchInfo.deviceIpInuse" size="mini"></el-input>
          </div>
        </div>
        <div class="search-main-item">
          <span>镜像备注:</span>
          <div class="item-input">
            <el-input v-model="searchInfo.remarkLike" size="mini"></el-input>
          </div>
        </div>
      </div>

      <div class="search-btn">
        <el-button type="primary" size="mini" @click="getAllMirrorListForSearch">搜索</el-button>
        <el-button size="mini" @click="advancedShow = false">取消</el-button>
        <el-button type="primary" size="mini" @click="cleanSearchInfo">重置搜索条件</el-button>
      </div>
    </div>

    <div class="device-case-dev border-all">
      <el-table ref="multipleTable" :data="allMirrorList.list" :height="tableHeight"
                :header-cell-style="{backgroundColor: '#efefef'}" stripe size="mini" tooltip-effect="dark"
                style="width: 99%" @selection-change="handleSelectionChange">
        <el-table-column type="index" label="ID"></el-table-column>
        <el-table-column prop="remark" label="镜像备注"></el-table-column>
        <el-table-column prop="updateTime" label="最后修改时间" width="150">
          <template slot-scope="scope">
            {{scope.row.updateTime | formatDateTime}}
          </template>
        </el-table-column>
        <el-table-column prop="deviceIpUpload" label="上传云机IP"></el-table-column>
        <el-table-column prop="deviceIpInuse" label="占用云机IP">
          <template slot-scope="scope">
            {{ scope.row.workStatus == 1 ? scope.row.deviceIpInuse : ""}}
          </template>
        </el-table-column>
        <el-table-column prop="proxyName" label="绑定IP代理"></el-table-column>
        <el-table-column prop="deviceVersion" label="设备版本">
          <template slot-scope="scope">
            {{ showEngineName(scope.row.engineType)}}
          </template>
        </el-table-column>
        <el-table-column prop="operationStatus" label="操作状态">
          <template slot-scope="scope">
            {{ scope.row.operationStatus | operationStatusStr }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="200px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="readMirrorRecord(scope.row)"
                       v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin && scope.row.operationStatus !== 12">查看记录
            </el-button>
            <el-button type="text" size="small" @click.stop="editMirrorRemark(scope.row)"
                       v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin  && scope.row.operationStatus !== 12">修改备注
            </el-button>
            <el-button type="text" size="small" @click.stop="cancelMirrorOccupation(scope.row.id)"
                       v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin  && scope.row.operationStatus !== 12"
                       :disabled="scope.row.workStatus !== 1">取消占用
            </el-button>
            <el-button type="text" size="small" @click.stop="cancelSwitchMirror(scope.row.id)"
                       v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin && scope.row.operationStatus == 12"
                       >取消切换
            </el-button>
            <el-button type="text" size="small" @click.stop="switchIpProxyPop(scope.row)"
                       v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin  && scope.row.operationStatus !== 12">切换IP
            </el-button>
            <el-button type="text" size="small" @click.stop="deleteMirrorRecord(scope.row.id)"
                       v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin && scope.row.workStatus == 0  && scope.row.operationStatus !== 12">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="list-bottom">
        <div class="list-bottom-btn">
        </div>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="page.startPage"
                :page-sizes="[10, 20, 50]"
                :page-size="page.limit"
                :pager-count="5"
                layout="total, sizes, prev, pager, next"
                :total="allMirrorList.total">
        </el-pagination>
      </div>
      <!-- 切换IP弹窗 -->
      <Drawer title="切换IP" :visible.sync="ipStartPopShow" @handClick="ipStart">
        <div style="font-size: 12px;">
          <span style="font-size: 14px;font-weight: 600;margin-right: 5px;">是否绑定IP代理：</span>
          <el-switch v-model="currentMirrorBindIp" :active-value="1"
                     :inactive-value="0" size="mini" class="ipproxy-switch"
                     active-text="是" inactive-text="否"
                     active-color="#40dfd0"></el-switch>
          <div style="margin-top: 20px;" v-if="currentMirrorBindIp">
              切换方式：
              <el-button-group>
                <el-button
                        :type="ipStartInfo.method !== 1 ? 'default' : 'primary'"
                        size="mini"
                        @click="switchProxyType(1)"
                >随机
                </el-button
                >
                <el-button
                        :type="ipStartInfo.method !== 2 ? 'default' : 'primary'"
                        size="mini"
                        @click="switchProxyType(2)"
                >指定IP
                </el-button
                >
              </el-button-group>
            </div>
            <div v-if="ipStartInfo.method === 2">
              <el-table
                      :data="ipProxyList"
                      size="mini"
                      ref="ipProxyTable"
                      :height="ipProxyTableHeight"
                      highlight-current-row
                      @current-change="handleCurrentChangeIp"
                      style="width: 100%"
              >
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="ip" label="IP"></el-table-column>
                <el-table-column
                        prop="connectionLast"
                        label="剩余连接数"
                ></el-table-column>
                <el-table-column
                        prop="proxyTypeText"
                        label="隧道协议"
                        :formatter="proxyTypeFormat"
                >
                </el-table-column>
              </el-table>
              <div class="ipproxy-list-bottom">
                <el-pagination
                        layout="total"
                        :total="ipProxyList.length">
                </el-pagination>
              </div>
            </div>
          </div>
      </Drawer>

      <Drawer title="修改镜像备注" :visible.sync="mirrorRemarkPopShow" @handClick="changeMirrorRemark">
        <el-form
                :model="currentMirror"
                label-width="100px"
                label-position="left"
        >
          <el-form-item size="mini" label="镜像ID：" prop="id">
            <span>{{ currentMirror.id }}</span>
          </el-form-item>
          <el-form-item size="mini" label="镜像备注：" prop="remark">
            <el-input v-model="currentMirror.remark"></el-input>
          </el-form-item>
        </el-form>
      </Drawer>
      <Drawer
              title="修改RSYNC"
              :visible.sync="saveRsyncPopShow"
              @handClick="saveRsync"
      >
        <div>
          <div style="font-size: 14px;">请设置RSYNC信息用于同步镜像：</div>
          <el-form
                  :model="rsyncInfo"
                  size="small"
                  label-width="150px"
                  label-position="left"
                  style="margin-top: 20px;"
          >
            <el-form-item
                    size="mini"
                    label="RSYNC服务器地址："
                    prop="address"
            >
              <el-input
                      size="mini"
                      v-model.trim="rsyncInfo.address.paramValue"
                      placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item size="mini" label="模块：">
              <el-input
                      size="mini"
                      v-model.trim="rsyncInfo.module.paramValue"
                      placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item size="mini" label="用户名：">
              <el-input
                      size="mini"
                      v-model.trim="rsyncInfo.username.paramValue"
                      placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item size="mini" label="密码：">
              <el-input
                      size="mini"
                      v-model.trim="rsyncInfo.password.paramValue"
                      placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </Drawer>
    </div>
  </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import {commonData} from '@/mixin'
    export default {
        name: "MirrorList",
        components: {
            Drawer
        },
        mixins:[commonData],
        data() {
            return {
                ipStartPopShow: false,
                currentMirrorBindIp: 0,
                currentMirrorBindProxyId: 0,
                ipStartInfo: {
                    ips: [],
                    proxyId: null,
                    msg: "",
                    autoConnect: 0,
                    method: 1,
                    last: 0,
                    global: 1,
                },
                ipProxyList: [],
                socks5List: [],
                ipProxyTableHeight:0,
                advancedShow: false,
                searchInfo: {
                    deviceIpInuse: "",
                    deviceIpUpload: "",
                    wordStatus: "",
                    engineType: "",
                    remarkLike:"",
                },
                defaultSearchInfo: {
                    deviceIpInuse: "",
                    deviceIpUpload: "",
                    wordStatus: "",
                    engineType: "",
                    remarkLike:"",
                },
                searchOptions: {
                    status: [
                        {
                            label: "未运行",
                            value: 0
                        }, {
                            label: "运行中",
                            value: 1
                        }
                    ],
                },
                rsyncAddress: '',
                rsyncModule: '',
                rsyncUserName: '',
                rsyncPassword: '',
                saveRsyncPopShow: false,
                mirrorRemarkPopShow: false,
                rsyncInfo: {
                    address: {
                        id: 0,
                        paramName: '',
                        paramValue: ''
                    },
                    module: {
                        id: 0,
                        paramName: '',
                        paramValue: ''
                    },
                    username: {
                        id: 0,
                        paramName: '',
                        paramValue: ''
                    },
                    password: {
                        id: 0,
                        paramName: '',
                        paramValue: ''
                    }
                },
                allMirrorList: {
                    list: [],
                    total: 0
                },
                currentMirror: {
                    id: '',
                    deviceIpUpload: '',
                    deviceIpInuse: '',
                    remark: '',
                    workStatus: 0,
                    operationStatus: 0,
                    createTime: '',
                    updateTime: '',
                },
                engineList: [],

            }
        },
        methods: {
            proxyTypeFormat(row, column) {
                if (row.proxyType === 2) {
                    return "PPTP";
                } else if (row.proxyType === 3) {
                    return "L2TP";
                } else if (row.proxyType === 4) {
                    return "Socks5";
                } else if (row.proxyType === 5) {
                    return "http";
                } else if (row.proxyType === 6) {
                    return "ssr";
                } else if (row.proxyType === 7) {
                    return "Socks5(UDP)";
                } else {
                    return "OpenVPN";
                }
            },
            ipStart() {
                if (
                    this.ipStartInfo.method === 2 &&
                    this.ipStartInfo.ips.length > this.ipStartInfo.last
                ) {
                    this.$confirm(
                        "当前剩余连接数不足以分配所选云机，请增加ip最大连接数，或者减少选择云机。",
                        "剩余连接数不足",
                        {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return;
                }

                let allLast = 0;
                if (this.ipStartInfo.method === 1) {
                    this.ipProxyList.forEach(ip => {
                        allLast += ip.connectionLast;
                    });
                }

                if (
                    this.ipStartInfo.method === 1 &&
                    this.ipStartInfo.ips.length > allLast
                ) {
                    this.$confirm(
                        "当前剩余连接数不足以分配所选云机，请增加ip最大连接数，或者减少选择云机。",
                        "剩余连接数不足",
                        {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return;
                }

                let proxyIdList = [];
                if (this.ipStartInfo.method === 1) {
                    this.ipProxyList.forEach(ip => {
                        for (let i = 0; i < ip.connectionLast; i++) {
                            proxyIdList.push(ip.id);
                        }
                    });
                    if (proxyIdList.length === 0) {
                        this.$confirm("没有可用的socks5代理", "提醒", {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            })
                            .catch(() => {
                            });
                        return;
                    }
                }

                let that = this;
                let proxyId = 0

                if (that.currentMirrorBindIp === 0) {
                    proxyId = 0;
                } else {
                    proxyId = this.ipStartInfo.proxyId;
                    if (this.ipStartInfo.method === 1) {
                        let index = Math.floor(Math.random() * proxyIdList.length);
                        proxyId = proxyIdList[index];
                        proxyIdList.splice(index, 1);
                    }
                }
                if (proxyId != that.currentMirrorBindProxyId) {
                    this.$confirm(
                        "确定要对当前镜像的IP代理进行修改设置?",
                        "警告",
                        {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: true
                        }
                    )
                        .then(() => {
                            that
                                .$post(that.$uri.deviceMirror.switchProxy, {
                                    id: that.currentMirror.id,
                                    proxyId: proxyId,
                                })
                                .then(res => {
                                    if (res.success) {
                                        that.$message.success("操作成功");
                                        this.ipStartPopShow = false;
                                        this.getAllMirrorList(false)
                                    }
                                });

                        })
                        .catch(() => {
                        });
                }
                else {
                    this.ipStartPopShow = false;
                }
            },
            handleCurrentChangeIp(row) {
                if (row != null) {
                    this.ipStartInfo.proxyId = row.id;
                    this.ipStartInfo.last = row.connectionLast;
                }
            },
            switchProxyType(val) {
                // console.log("val is " + val)
                this.ipStartInfo.method = val
                if (this.ipStartInfo.method === 2) {
                    this.$nextTick().then(() => {
                        if (this.$refs.ipProxyTable) {
                            this.ipProxyTableHeight = window.innerHeight - this.$refs.ipProxyTable.$el.offsetTop - 100;
                        }
                    })
                }
            },
            switchIpProxyPop(row) {
                let that = this;
                let params = {}
                this.currentMirror = JSON.parse(JSON.stringify(row))
                if (this.$store.state.userInfo.groupType == 2) {
                    params = {userId: this.$store.state.userInfo.id}
                }
                this.currentMirrorBindProxyId = this.currentMirror.proxyId
                if (this.currentMirror.proxyId !== 0) {
                    this.currentMirrorBindIp = 1
                } else {
                    this.currentMirrorBindIp = 0
                }
                that.$post(that.$uri.ipProxy.list, params).then(res => {
                    if (res.success) {
                        let list = res.list.filter(i => {
                            return i.isUsable === 1;
                        });
                        list.sort((a, b) => {
                            return b.connectionLast - a.connectionLast;
                        });
                        that.ipProxyList = list;
                        that.socks5List = list.filter(ip => {
                            return ip.proxyType === 4 || ip.proxyType === 6;
                        });
                        // console.log("ipProxyList is " + JSON.stringify(that.ipProxyList))
                    }
                });
                this.ipStartPopShow = true;
            },
            showEngineName(deviceType) {
                let engineName = ""
                if (this.engineList.length > 0 && deviceType) {
                    this.engineList.forEach(item => {
                        if (item.value == deviceType) {
                            engineName = item.label
                            return
                        }
                    })
                }
                return engineName
            }
            ,
            /* 获取所有引擎版本信息 */
            getEngineVersion() {
                this.$post(this.$uri.system.engineCodeList, {}).then(res => {
                    let list = [];
                    res.list.forEach(v => {
                        list.push({
                            label: v.content,
                            value: v.code
                        });
                    });
                    this.engineList = list;
                    // console.log("engineList is " + JSON.stringify(that.engineList))
                });
            }
            ,
            cleanSearchInfo() {
                this.searchInfo = JSON.parse(JSON.stringify(this.defaultSearchInfo))
                // console.log("searchInfo is " + JSON.stringify(this.searchInfo))
                this.getAllMirrorListForSearch(false)
            }
            ,
            getAllMirrorList(first) {
                this
                    .$post(this.$uri.deviceMirror.list, {...this.page, ...this.searchInfo})
                    .then(res => {
                        // console.log("allMirrorList is " + JSON.stringify(res))
                        if (res.success) {
                            this.allMirrorList.list = res.list
                            this.allMirrorList.total = res.total
                            console.log("allMirrorList is " + JSON.stringify(this.allMirrorList))
                            if (first) {
                                this.$nextTick().then(() => {
                                    this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                                })
                            }
                        }
                    });
            }
            ,
            getAllMirrorListForSearch() {
                this.page.startPage = 1
                this
                    .$post(this.$uri.deviceMirror.list, {...this.page, ...this.searchInfo})
                    .then(res => {
                        // console.log("allMirrorList is " + JSON.stringify(res))
                        if (res.success) {
                            this.allMirrorList.list = res.list
                            this.allMirrorList.total = res.total
                            console.log("allMirrorList is " + JSON.stringify(this.allMirrorList))
                        }
                    });
            }
            ,
            changeMirrorRemark() {
                let that = this;
                that
                    .$post(that.$uri.deviceMirror.saveEdit, {...that.currentMirror}).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    if (res.success) {
                        that.getAllMirrorList(false)
                    }
                });
            }
            ,
            saveRsync() {
                let that = this
                if (that.rsyncAddress !== that.rsyncInfo.address.paramValue) {
                    that
                        .$post(that.$uri.system.paramSave, that.rsyncInfo.address)
                        .then(res => {
                            if (res.success) {
                                that.rsyncAddress = that.rsyncInfo.address.paramValue
                            } else {
                                that.$message.error("设置RSYNC地址失败")
                            }
                        });
                }
                if (that.rsyncModule !== that.rsyncInfo.module.paramValue) {
                    that
                        .$post(that.$uri.system.paramSave, that.rsyncInfo.module)
                        .then(res => {
                            if (res.success) {
                                that.rsyncModule = that.rsyncInfo.module.paramValue
                            } else {
                                that.$message.error("设置RSYNC模块失败")
                            }
                        });
                }
                if (that.rsyncUserName !== that.rsyncInfo.username.paramValue) {
                    that
                        .$post(that.$uri.system.paramSave, that.rsyncInfo.username)
                        .then(res => {
                            if (res.success) {
                                that.rsyncUserName = that.rsyncInfo.username.paramValue
                            } else {
                                that.$message.error("设置RSYNC用户名失败")
                            }
                        });
                }
                if (that.rsyncPassword !== that.rsyncInfo.password.paramValue) {
                    that
                        .$post(that.$uri.system.paramSave, that.rsyncInfo.password)
                        .then(res => {
                            if (res.success) {
                                that.rsyncPassword = that.rsyncInfo.password.paramValue
                            } else {
                                that.$message.error("设置RSYNC密码失败")
                            }
                        });
                }
                setTimeout(function () {
                    that.$message.success("设置RSYNC成功")
                    that.saveRsyncPopShow = false
                    that.saveContainerPopShow = true
                }, 1000)
            }
            ,
            getRsyncParams() {
                let that = this;
                that
                    .$post(that.$uri.system.paramGet, {paramName: "deviceMirrorRsyncHost"})
                    .then(res => {
                        // console.log("res is " + JSON.stringify(res))
                        if (res.success && res.data) {
                            that.rsyncInfo.address.id = res.data.id;
                            that.rsyncInfo.address.paramName = res.data.paramName;
                            that.rsyncInfo.address.paramValue = res.data.paramValue;
                            that.rsyncAddress = that.rsyncInfo.address.paramValue
                            // console.log("rsyncInfo is " + JSON.stringify(that.rsyncInfo))
                        }
                    });
                that
                    .$post(that.$uri.system.paramGet, {paramName: "deviceMirrorRsyncModule"})
                    .then(res => {
                        if (res.success && res.data) {
                            that.rsyncInfo.module.id = res.data.id;
                            that.rsyncInfo.module.paramName = res.data.paramName;
                            that.rsyncInfo.module.paramValue = res.data.paramValue;
                            that.rsyncModule = that.rsyncInfo.module.paramValue
                        }
                    });
                that
                    .$post(that.$uri.system.paramGet, {paramName: "deviceMirrorRsyncUsername"})
                    .then(res => {
                        if (res.success && res.data) {
                            that.rsyncInfo.username.id = res.data.id;
                            that.rsyncInfo.username.paramName = res.data.paramName;
                            that.rsyncInfo.username.paramValue = res.data.paramValue;
                            that.rsyncUserName = that.rsyncInfo.username.paramValue
                        }
                    });
                that
                    .$post(that.$uri.system.paramGet, {paramName: "deviceMirrorRsyncPassword"})
                    .then(res => {
                        if (res.success && res.data) {
                            that.rsyncInfo.password.id = res.data.id;
                            that.rsyncInfo.password.paramName = res.data.paramName;
                            that.rsyncInfo.password.paramValue = res.data.paramValue;
                            that.rsyncPassword = that.rsyncInfo.password.paramValue
                        }
                    });
            }
            ,
            readMirrorRecord(row) {
                this.currentMirror = JSON.parse(JSON.stringify(row))
                this.$store.commit(this.$mutation.MIRROR_RECORD, row);
                this.$router.push("/home/mirrorRecord");
            }
            ,
            editMirrorRemark(row) {
                this.currentMirror = JSON.parse(JSON.stringify(row))
                this.mirrorRemarkPopShow = true
            }
            ,
            cancelMirrorOccupation(id) {
                console.log("cancelMirrorOccupation for " + id)
                this.$confirm(
                    "取消占用的功能主要解决设备异常并且占用镜像的情况，确认要执行此操作?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-blue",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        let that = this
                        that.$post(that.$uri.deviceMirror.cancelOccupation, {id: id})
                            .then(res => {
                                console.log("res is " + JSON.stringify(res))
                                if (res.success) {
                                    that.$message.success("取消占用成功")
                                    that.getAllMirrorList(false)
                                }
                            })
                    })
                    .catch(() => {
                    });
            }
            ,
            cancelSwitchMirror(id) {
                this.$confirm("确认要取消当前的镜像切换操作?", "提醒", {
                    confirmButtonText: "确认",
                    confirmButtonClass: "confirm-btn-blue",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消",
                    showCancelButton: false
                })
                    .then(() => {
                        let that = this;
                        that.$post(that.$uri.deviceMirror.cancel, {id: id}).then(res => {
                            if (res.success) {
                                that.$message.success("取消切换成功")
                                that.getAllMirrorList(false)
                            } else {
                                that.$message.success("取消切换失败")
                            }
                        });
                    }).catch(() => {
                })
            },
            deleteMirrorRecord(id) {
                console.log("deleteMirrorRecord " + id)
                this.$confirm(
                    "镜像文件存储于RSYNC服务器，需自行删除，确定要删除此记录?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-blue",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        let that = this
                        that.$post(that.$uri.deviceMirror.delete, {id: id})
                            .then(res => {
                                console.log("res is " + JSON.stringify(res))
                                if (res.success) {
                                    that.$message.success("删除成功")
                                    that.getAllMirrorList(false)
                                }
                            })
                    })
                    .catch(() => {
                    });
            }
            ,
            /* 表单击行事件 */
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            }
            ,
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
            }
            ,

            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getAllMirrorList(false)
            }
            ,
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getAllMirrorList(false)
            }
            ,
        }
        ,
        filters: {
            operationStatusStr(status) {
                switch (status) {
                    case 0:
                        return '准备中'
                    case 1:
                        return '保存中'
                    case 2:
                        return '保存失败'
                    case 3:
                        return '上传中'
                    case 4:
                        return '上传失败'
                    case 5:
                        return '上传成功'
                    case 10:
                        return '下载中'
                    case 11:
                        return '下载失败'
                    case 12:
                        return '切换中'
                    case 13:
                        return '切换失败'
                    case 14:
                        return '切换成功'
                    case 20:
                        return '命令发送失败'
                }
            }
        }
        ,
        beforeMount() {
            this.getEngineVersion()
        }
        ,
        mounted() {
            this.getRsyncParams()
            this.getAllMirrorList(true);
        }
    };
</script>

<style lang="less" scoped>
  .mirror-list {
    .rsync-server {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 30px;
    }
    .search-advanced {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      border: 1px solid #efefef;
      .search-main {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        .search-main-item {
          margin-right: 8%;
          width: 24%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          /*flex-grow: 1;*/
          padding: 5px 10px;
          span {
            font-size: 12px;
            width: 100px;
          }
          .item-input {
            /*margin-left: 30px;*/
            width: 180px;
          }
        }
      }
      .search-btn {
        padding: 20px 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }
    .device-case-dev {
      margin-top: 10px;
      .list-bottom {
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .list-bottom-btn {
          display: flex;
          flex-direction: row;
        }
      }
    }
  }

  .question-icon {
    margin-left: 5px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 50%;
    background-color: grey;
    color: white;
    display: inline-block;
    position: relative;
  }
  .ipproxy-list-bottom {
    padding: 10px 8px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
  }
</style>